// extracted by mini-css-extract-plugin
module.exports = {"aiMarkdown":"AiMarkdown_aiMarkdown__bhuWC","tableWrap":"AiMarkdown_tableWrap__C2dGG"};